import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { bootstrapPendingAlipayReturn } from './lib/payment-methods';
import './index.css';

const restoredAlipaySource = bootstrapPendingAlipayReturn(
  window.location.pathname,
  window.location.search,
  window.location.hash,
);
if (restoredAlipaySource) {
  window.history.replaceState(window.history.state, '', restoredAlipaySource);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
